import { forceUpdate, h } from "@stencil/core";
import { fromGxImageToURL } from "../tree-view/genexus-implementation";
const DEFAULT_ACTION_CLASS = "action-group-item";
const DEFAULT_SUB_ACTION_CLASS = "dropdown-item";
export class ChActionGroupRender {
    constructor() {
        this.displayedItemsCount = -1;
        this.moreActionsButtonWasExpanded = false;
        this.buttonLabel = "Show options";
        this.cssClass = "action-group";
        this.expandBehavior = "ClickOrHover";
        this.gxImageConstructor = undefined;
        this.gxSettings = undefined;
        this.itemClickCallback = undefined;
        this.itemsOverflowBehavior = "ResponsiveCollapse";
        this.model = undefined;
        this.openOnFocus = false;
        this.moreActionsDropdownPosition = "InsideStart_OutsideEnd";
        this.separation = 0;
        this.useGxRender = false;
    }
    // /**
    //  * Fired when the visibility of the dropdown section is changed
    //  */
    // @Event() expandedChange: EventEmitter<boolean>;
    handleItemClick = (target, itemId) => (event) => {
        this.itemClickCallback(event, target, itemId);
    };
    renderImg = (img) => this.useGxRender
        ? fromGxImageToURL(img, this.gxSettings, this.gxImageConstructor)
        : img;
    renderItem = (responsiveCollapse) => (item, index) => (h("ch-dropdown-item", { slot: "items", key: item.id || item.caption || index, id: item.id, class: item.subActionClass || DEFAULT_SUB_ACTION_CLASS, expandBehavior: this.expandBehavior, href: item.link?.url, leftImgSrc: this.renderImg(item.startImage), openOnFocus: this.openOnFocus, position: (responsiveCollapse
            ? item.itemsResponsiveCollapsePosition
            : item.itemsPosition) || "OutsideEnd_InsideStart", rightImgSrc: this.renderImg(item.endImage), shortcut: item.shortcut, onClick: this.handleItemClick(item.link?.url, item.id), onExpandedChange: !item.wasExpanded
            ? this.handleItemExpanded(item, "wasExpanded")
            : null }, item.caption, item.items != null &&
        item.wasExpanded &&
        item.items.map(this.renderItem(responsiveCollapse)), 
    // Render a dummy element if the control was not expanded and has items
    item.items != null && !item.wasExpanded && (h("ch-dropdown-item", null))));
    firstLevelRenderItem = (item, index) => {
        // Dummy dropdown item to avoid issues when removing all items from the
        // first level. E. g., if the first level adds a chevron when the item is
        // a dropdown, by removing all items the chevron won't be displayed
        const mustRenderDummySubElement = item.items != null &&
            item.items.length !== 0 && // Dropdown has items
            (!item.wasExpanded || // Dropdown was not expanded and has items
                (this.itemsOverflowBehavior === "ResponsiveCollapse" && // Dropdown items are collapsed
                    this.displayedItemsCount !== -1 &&
                    index >= this.displayedItemsCount));
        return (h("ch-dropdown-item", { key: item.id || item.caption || index, id: item.id, class: item.actionClass || DEFAULT_ACTION_CLASS, expandBehavior: this.expandBehavior, forceContainingBlock: false, href: item.link?.url, leftImgSrc: this.renderImg(item.startImage), openOnFocus: this.openOnFocus, position: item.itemsPosition || "Center_OutsideEnd", rightImgSrc: this.renderImg(item.endImage), onClick: this.handleItemClick(item.link?.url, item.id), onExpandedChange: !item.wasExpandedInFirstLevel
                ? this.handleItemExpanded(item, "wasExpandedInFirstLevel")
                : null }, item.caption, item.wasExpandedInFirstLevel &&
            this.itemsOverflowBehavior === "ResponsiveCollapse" &&
            (this.displayedItemsCount === -1 ||
                index < this.displayedItemsCount) &&
            item.items != null &&
            item.items.map(this.renderItem(false)), mustRenderDummySubElement && h("ch-dropdown-item", null)));
    };
    handleItemExpanded = (item, propertyName) => () => {
        item[propertyName] = true;
        forceUpdate(this);
    };
    firstLevelRenderCollapsedItem = (item, index) => (h("ch-dropdown-item", { slot: "more-items", key: item.id || item.caption || index, id: item.id, class: item.subActionClass || DEFAULT_SUB_ACTION_CLASS, expandBehavior: this.expandBehavior, href: item.link?.url, leftImgSrc: this.renderImg(item.startImage), openOnFocus: this.openOnFocus, position: item.itemsResponsiveCollapsePosition || "OutsideEnd_InsideStart", rightImgSrc: this.renderImg(item.endImage), shortcut: item.shortcut, onClick: this.handleItemClick(item.link?.url, item.id), onExpandedChange: !item.wasExpandedInMoreActions
            ? this.handleItemExpanded(item, "wasExpandedInMoreActions")
            : null }, item.caption, 
    // Render items when the parent is expanded the first time
    item.items != null &&
        item.wasExpandedInMoreActions &&
        item.items.map(this.renderItem(true)), 
    // Render a dummy element if the control was not expanded and has items
    item.items != null && !item.wasExpandedInMoreActions && (h("ch-dropdown-item", null))));
    handleDisplayedItemsCountChange = (event) => {
        this.displayedItemsCount = event.detail;
    };
    handleMoreActionButtonExpandedChange = () => {
        this.moreActionsButtonWasExpanded = true;
    };
    render() {
        const thereAreCollapsedItems = this.itemsOverflowBehavior === "ResponsiveCollapse" &&
            this.moreActionsButtonWasExpanded &&
            this.model != null &&
            this.displayedItemsCount !== -1;
        return (h("ch-action-group", { buttonLabel: this.buttonLabel, class: this.cssClass || null, expandBehavior: this.expandBehavior, itemsOverflowBehavior: this.itemsOverflowBehavior, moreActionsDropdownPosition: this.moreActionsDropdownPosition, openOnFocus: this.openOnFocus, onDisplayedItemsCountChange: this.handleDisplayedItemsCountChange, onMoreActionsButtonExpandedChange: !this.moreActionsButtonWasExpanded
                ? this.handleMoreActionButtonExpandedChange
                : null }, this.model != null &&
            this.model.map((item, index) => (h("ch-action-group-item", { slot: "items", key: item.id || item.caption || index }, this.firstLevelRenderItem(item, index)))), thereAreCollapsedItems &&
            this.model
                .filter((_, index) => index >= this.displayedItemsCount)
                .map(this.firstLevelRenderCollapsedItem)));
    }
    static get is() { return "ch-action-group-render"; }
    static get originalStyleUrls() {
        return {
            "$": ["action-group-render.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["action-group-render.css"]
        };
    }
    static get properties() {
        return {
            "buttonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute lets you specify the label for the expandable button.\nImportant for accessibility."
                },
                "attribute": "button-label",
                "reflect": false,
                "defaultValue": "\"Show options\""
            },
            "cssClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-action-group` element class."
                },
                "attribute": "css-class",
                "reflect": false,
                "defaultValue": "\"action-group\""
            },
            "expandBehavior": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"Click\" | \"ClickOrHover\"",
                    "resolved": "\"Click\" | \"ClickOrHover\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine which actions on the expandable button display the dropdown\nsection."
                },
                "attribute": "expand-behavior",
                "reflect": false,
                "defaultValue": "\"ClickOrHover\""
            },
            "gxImageConstructor": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(name: string) => any",
                    "resolved": "(name: string) => any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                }
            },
            "gxSettings": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                },
                "attribute": "gx-settings",
                "reflect": false
            },
            "itemClickCallback": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(\n    event: UIEvent,\n    target: string,\n    itemId: string\n  ) => void",
                    "resolved": "(event: UIEvent, target: string, itemId: string) => void",
                    "references": {
                        "UIEvent": {
                            "location": "global",
                            "id": "global::UIEvent"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This callback is executed when an item is clicked."
                }
            },
            "itemsOverflowBehavior": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ItemsOverflowBehavior",
                    "resolved": "\"AddScroll\" | \"Multiline\" | \"ResponsiveCollapse\"",
                    "references": {
                        "ItemsOverflowBehavior": {
                            "location": "import",
                            "path": "../../action-group/action-group/types",
                            "id": "src/components/action-group/action-group/types.ts::ItemsOverflowBehavior"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute determines how items behave when the content of the ActionGroup overflows horizontal. This property is needed\nto make the control responsive to changes in the Width of the container of ActionGroup.\n\n| Value                 | Details                                                                                          |\n| --------------------- | ------------------------------------------------------------------------------------------------ |\n| `Add Scroll`          | The items of the ActionGroup that overflow horizontally are shown by means of a scroll.          |\n| `Multiline`           | The ActionGroup items that overflow horizontally are shown in a second line of the control.      |\n| `Responsive Collapse` | The Action Group items, when they start to overflow the control, are placed in the More Actions. |"
                },
                "attribute": "items-overflow-behavior",
                "reflect": false,
                "defaultValue": "\"ResponsiveCollapse\""
            },
            "model": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "ActionGroupItemModel[]",
                    "resolved": "ActionGroupItemModel[]",
                    "references": {
                        "ActionGroupItemModel": {
                            "location": "import",
                            "path": "./types",
                            "id": "src/components/renders/action-group/types.ts::ActionGroupItemModel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property lets you define the model of the ch-action-group control."
                }
            },
            "openOnFocus": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine if the dropdown section should be opened when the expandable\nbutton of the control is focused."
                },
                "attribute": "open-on-focus",
                "reflect": false,
                "defaultValue": "false"
            },
            "moreActionsDropdownPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "DropdownPosition",
                    "resolved": "\"Center_OutsideEnd\" | \"Center_OutsideStart\" | \"InsideEnd_OutsideEnd\" | \"InsideEnd_OutsideStart\" | \"InsideStart_OutsideEnd\" | \"InsideStart_OutsideStart\" | \"OutsideEnd_Center\" | \"OutsideEnd_InsideEnd\" | \"OutsideEnd_InsideStart\" | \"OutsideEnd_OutsideEnd\" | \"OutsideEnd_OutsideStart\" | \"OutsideStart_Center\" | \"OutsideStart_InsideEnd\" | \"OutsideStart_InsideStart\" | \"OutsideStart_OutsideEnd\" | \"OutsideStart_OutsideStart\"",
                    "references": {
                        "DropdownPosition": {
                            "location": "import",
                            "path": "../../dropdown/types",
                            "id": "src/components/dropdown/types.ts::DropdownPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the position of the dropdown section that is placed relative to\nthe more actions button."
                },
                "attribute": "more-actions-dropdown-position",
                "reflect": false,
                "defaultValue": "\"InsideStart_OutsideEnd\""
            },
            "separation": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies the separation (in pixels) between the expandable button and the\ndropdown section of the control."
                },
                "attribute": "separation",
                "reflect": false,
                "defaultValue": "0"
            },
            "useGxRender": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA to implement the Tree View as a UC 2.0 in GeneXus."
                },
                "attribute": "use-gx-render",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "displayedItemsCount": {},
            "moreActionsButtonWasExpanded": {}
        };
    }
}
//# sourceMappingURL=action-group-render.js.map
